// extracted by mini-css-extract-plugin
export var infoItem = "_sz-2";
export var title = "_sz-0";
export var value = "_sz-1";